import React from "react";
import { Tooltip } from "antd";
import { Zap, Brain } from "lucide-react";
import type { ThinkMode } from "@/lib/types";

interface ChatModeToggleProps {
  thinkMode: ThinkMode;
  onChange: (mode: ThinkMode) => void;
  disabled?: boolean;
}

const ChatModeToggle: React.FC<ChatModeToggleProps> = ({
  thinkMode,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="chat-mode-toggle">
      <Tooltip title="Quick Response" placement="top">
        <button
          type="button"
          className={`chat-mode-btn ${thinkMode === "lite" ? "active" : ""}`}
          onClick={() => onChange("lite")}
          disabled={disabled}
          aria-label="Lite mode"
        >
          <Zap size={13} />
          <span>Lite</span>
        </button>
      </Tooltip>
      <Tooltip title="Deep Analysis with AI Agent" placement="top">
        <button
          type="button"
          className={`chat-mode-btn ${thinkMode === "deep" ? "active deep" : ""}`}
          onClick={() => onChange("deep")}
          disabled={disabled}
          aria-label="Deep Thinking mode"
        >
          <Brain size={13} />
          <span>Deep</span>
        </button>
      </Tooltip>
    </div>
  );
};

export default ChatModeToggle;
